export default __webpack_public_path__ + "static/media/twitter.884c4b86.svg";